import { LanguagesEnum } from '@/api/enums';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentUser } from '@/store/features/users';
import { selectCurrentUserFeatureAbility } from '@/store/features/users/current-user.slice';
import { isLanguageAllowedForAdmin, isThereTranslation } from '@/utils/helpers';
import {
  Calendar,
  CalendarProps,
  CalendarSelectionMode,
} from 'primereact/calendar';
import React from 'react';
import styled from 'styled-components';

const StyledCalendar = styled(Calendar)`
  &.p-calendar {
    &.p-calendar-w-btn.p-calendar-w-btn-left {
      .p-button {
        background-color: var(--beige-main);
        color: var(--black-main);
        border: none;
        border-start-start-radius: var(--default-border-radius);
        border-bottom-left-radius: var(--default-border-radius);
        padding-left: var(--small-padding);
        span {
          font-size: var(--medium-font-size);
        }
      }

      .p-inputtext {
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
      }

      .p-inputtext:enabled:hover:not(.p-invalid),
      .p-inputtext:enabled:focus:not(.p-invalid) {
        box-shadow: none;
        border-color: var(--beige-main);
      }

      &.p-focus > .p-inputtext:not(.p-invalid) {
        box-shadow: none !important;
      }

      &:focus-within {
        box-shadow: var(--box-shadow-red-no-blur);
        border-radius: var(--default-border-radius);
      }
    }
  }

  &.white-input {
    .p-inputtext,
    .p-button {
      background-color: var(--white-main) !important;
      border-color: var(--white-main);
    }
  }
`;

const AppCalendar = <TMode extends CalendarSelectionMode = 'single'>({
  dateFormat = 'M dd, yy',
  ...rest
}: CalendarProps<TMode>) => {
  const user = useAppSelector(selectCurrentUser);
  const userFeatureAbility = useAppSelector(selectCurrentUserFeatureAbility);

  return (
    <StyledCalendar
      locale={
        isThereTranslation() &&
        isLanguageAllowedForAdmin(user?.language, userFeatureAbility)
          ? user?.language
          : LanguagesEnum.EN
      }
      dateFormat={dateFormat}
      {...(rest as CalendarProps)}
    />
  );
};

export default AppCalendar;
